const styles = {
    headerSection: {
        p: 4,
        mb: 4,
        borderRadius: 2,
        backgroundColor: 'primary.main',
        color: '#fff',
    },
    notificationIcon: {
        fontSize: 40,
        mr: 3,
    },
    notificationTitle: {
        mb: 1,
    },
    notificationSubtitle: {
        opacity: 0.9,
    },
    headerButton: {
        fontSize: '1rem',
        py: 1.5,
        px: 3,
        borderColor: 'rgba(255,255,255,0.5)',
        '&:hover': {
            borderColor: '#fff',
            backgroundColor: 'rgba(255,255,255,0.1)',
        },
    },
    refreshButton: {
        fontSize: { xs: '0.8rem', sm: '0.875rem' },
        py: { xs: 0.75, sm: 1 },
        px: { xs: 1.5, sm: 2 },
        borderColor: 'rgba(255,255,255,0.5)',
        '&:hover': {
            borderColor: '#fff',
            backgroundColor: 'rgba(255,255,255,0.1)',
        },
    },
    notificationsTable: {
        borderRadius: 2,
        overflow: 'hidden',
        width: '100%',
        minHeight: '400px',
    },
    loadingBox: {
        p: 8,
        textAlign: 'center',
    },
    emptyNotificationsBox: {
        p: 8,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
    },
    emptyNotificationsIcon: {
        fontSize: 64,
        color: 'text.secondary',
        mb: 3,
    },
    emptyNotificationsText: {
        mb: 2,
    },
    dataGrid: {
        width: '100%',
        fontSize: '0.97rem',
        '& .MuiDataGrid-cell:focus': {
            outline: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'grey.100',
            fontSize: '1.05rem',
            fontWeight: 600,
            textAlign: 'center',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            width: '100%',
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex',
        },
        '& .MuiDataGrid-row': {
            minHeight: 48,
            maxHeight: 60,
        },
        '& .MuiDataGrid-row:hover': {
            backgroundColor: 'grey.50',
        },
        '& .MuiDataGrid-cell': {
            py: 1,
            px: 1.5,
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
    },
    dialogTitle: {
        p: 0,
        background: 'primary.main',
        color: '#fff',
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
    },
    dialogTitleBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 3,
        py: 2,
    },
    dialogChip: (status) => ({
        fontWeight: 500,
        fontSize: '0.92rem',
        px: 1.5,
        background: status === 'unread' ? 'primary.light' : 'grey.100',
    }),
    dialogContent: {
        p: 0,
        maxHeight: 500,
    },
    dialogBox: {
        px: 3,
        py: 2,
    },
    messagePaper: {
        p: 2,
        mb: 2,
        background: 'grey.50',
        maxHeight: 120,
        overflowY: 'auto',
    },
    senderRecipientPaper: {
        p: 2,
        background: 'grey.50',
    },
    rawJsonButton: {
        textTransform: 'none',
    },
    rawJsonPaper: {
        mt: 1,
        p: 2,
        background: '#222',
        color: '#fff',
        fontSize: '0.92rem',
        maxHeight: 200,
        overflow: 'auto',
    },
    dialogActions: {
        px: 3,
        py: 2,
        background: 'grey.50',
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
    },
    dialogButton: {
        fontSize: '0.97rem',
        py: 0.7,
        px: 2,
    },
};

export default styles; 